import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { CheckIcon } from './icons/check_icon';
export const CheckBox = (props) => {
    const [value, setValue] = React.useState(false);
    const onClick = () => {
        setValue(!value);
        props.onChange();
    };
    return (React.createElement("label", { className: css(styles.container, props.classObject), "data-test": props.dataTest },
        value ? (React.createElement(CheckIcon, { color: Colors.White, classObject: [styles.checkIcon, styles.checked] })) : (React.createElement("div", { className: css(styles.checkIcon, styles.noChecked) })),
        React.createElement("input", { className: css(styles.checkbox), type: "checkbox", onChange: onClick }),
        React.createElement("span", { className: css(styles.label, props.labelClassObject) }, props.children)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    checkIcon: {
        width: 16,
        height: 16,
        marginRight: 8,
        borderRadius: 2,
        cursor: 'pointer',
    },
    checked: {
        backgroundColor: Colors.PrimaryDark,
    },
    noChecked: {
        border: `1px solid ${Colors.Gray}`,
    },
    label: {
        color: Colors.GrayDarkest,
        fontSize: 12,
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    checkbox: {
        display: 'none',
    },
});
